"use client";

import { X } from "lucide-react";
import type { ActiveChip } from "./types";

interface Props {
  chips: ActiveChip[];
  onRemove: (chip: ActiveChip) => void;
  onClearAll: () => void;
}

export function ActiveFilterChips({ chips, onRemove, onClearAll }: Props) {
  if (chips.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {chips.map((chip) => (
        <button
          key={`${chip.groupId}-${chip.value}`}
          type="button"
          onClick={() => onRemove(chip)}
          className="inline-flex items-center gap-1 px-2.5 h-7 rounded-full border bg-card text-xs font-medium hover:bg-muted transition-colors"
        >
          <span className="truncate max-w-[180px]">{chip.label}</span>
          <X className="w-3 h-3 shrink-0 text-muted-foreground" />
        </button>
      ))}
      {chips.length > 1 && (
        <button
          type="button"
          onClick={onClearAll}
          className="inline-flex items-center h-7 px-2.5 text-[11px] font-bold text-muted-foreground hover:text-foreground underline-offset-2 hover:underline"
        >
          Limpiar todos
        </button>
      )}
    </div>
  );
}
